import {
  RetweetOutlined,
  CreditCardOutlined,
  DatabaseOutlined,
  CoffeeOutlined,
  GiftOutlined,
} from "@ant-design/icons";
import { ADMIN_PREFIX_PATH } from "configs/AppConfig";

const dashBoardNavTree = [
  {
    key: "master-voucher",
    path: `${ADMIN_PREFIX_PATH}/master-voucher`,
    title: "Data Voucher",
    icon: GiftOutlined,
    permissions: [
      "ASSIGN_VOUCHERS",
      "CREATE_VOUCHERS",
      "DELETE_VOUCHERS",
      "GET_LIST_USER_VOUCHERS",
      "GET_VOUCHERS",
      "UPDATE_STATUS_VOUCHERS",
      "UPDATE_VOUCHERS",
      "UPDATE_VOUCHERS_IMAGE",
    ],
    breadcrumb: false,
    submenu: [],
  },
  {
    key: "master-kasir",
    path: `${ADMIN_PREFIX_PATH}/master-kasir`,
    title: "Data Kasir",
    icon: DatabaseOutlined,
    permissions: [
      "CREATE_CASHIER_POS",
      "DELETE_CASHIER_POS",
      "GET_CASHIER_POS",
      "UPDATE_CASHIER_POS",
    ],
    breadcrumb: false,
    submenu: [],
  },
  {
    key: "rekap-transaksi",
    path: `${ADMIN_PREFIX_PATH}/cafe/rekap-transaksi`,
    title: "Rekap Transaksi",
    icon: RetweetOutlined,
    permissions: [
      "GET_TRANSACTION_CHART_POS",
      "GET_TRANSACTION_POS",
      "GET_TRANSACTION_RECAP_POS",
      "GET_VENDOR_TRANSACTION_RECAP_POS",
    ],
    breadcrumb: false,
    submenu: [],
  },
  {
    key: "pencairan-dana",
    path: `${ADMIN_PREFIX_PATH}/cafe/pencairan-dana`,
    title: "Pencairan Dana",
    icon: CreditCardOutlined,
    permissions: [
      "GET_VENDOR_DISBURSEMENTS_POS",
      "GET_VENDOR_DISBURSEMENTS_STATUS_POS",
    ],
    breadcrumb: false,
    submenu: [],
  },
];

const navigationConfigAdminCafe = [...dashBoardNavTree];

export default navigationConfigAdminCafe;
